import ProfilePage from '../../components/pages/profile/profilePage'

export const profileRootPages = {
  path: '/profile',
  name: 'profile_form_route',
  component: ProfilePage
}
